<template>
  <div id="nurturing" class="mt-5" v-if="gallerySlider && galleryNutriendo">
    <main class="main-content border-radius-lg justify-content-center mb-0">
      <div class="container-fluid justify-content-center">
        <div class="row justify-content-center">
          <div class="col-sm-6 col-12">
            <div class="card z-index-2 h-100">
              <div class="card-header pb-0 pt-3" v-if="galleryNutriendo.images_url.length  !== 0">
                <img :src="galleryNutriendo.images_url[0]" style="width: 70%;" alt="">
              </div>
              <div class="card-body p-3">
                <div class="justify-content-center" style="text-align: justify">
                  <small>{{ nurturing }}</small> <br>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-12">
            <div class="card-carousel w-100" v-if="gallerySlider.images_url.length != 0">
              <div id="carouselExampleCaptions2" class="carousel slide w-100" data-bs-ride="carousel">
                <div class="carousel-inner border-radius-lg w-100">
                  <div v-for="(image, index) in gallerySlider.images_url" :key="image"
                    :class="index === 0 ? 'carousel-item w-100 active' : 'carousel-item w-100'">
                    <img :src="image" alt="" class="d-block w-100">
                  </div>
                </div>
                <button class="carousel-control-prev w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions2"
                  data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions2"
                  data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid justify-content-center">
        <div class="row justify-content-center">
          <div class="col-sm-3 col-12 justify-content-center align-content-center"
            v-if="galleryNutriendo.images_url.length !== 0">
            <img :src="galleryNutriendo.images_url[1]" style="width: 300px;" alt="">
          </div>
          <div class="col-sm-7 col-12 d-flex justify-content-start align-items-center">
            <a target="_blank" class="font-weight-bold"
              :href="nurturinglink">
              <h4>Conoce mas en:</h4>
              <small class="text-center" style="font-size: 2em; font-weight: bold;">nutriendo.org</small>
            </a>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
  
<script>
export default {
  name: "nutriendo",
  data() {
    return {
      gallerySlider: undefined,
      galleryNutriendo: undefined
    };
  },
  props: {
    nurturing: {
      type: String,
      request: true,
    },
    nurturinglink: {
      type: String,
      request: true,
    },
  },
  created() {
    this.plain
      .get(`/galleriesName?title=Fundación Nutriendo (Slider)`)
      .then((response) => {
        this.gallerySlider = response.data
        // console.log(response);
      })
      .catch((err) => {
        this.gallerySlider = undefined;
        console.log(err);
      })
      .finally(() => {
        this.plain
          .get(`/galleriesName?title=Fundación Nutriendo`)
          .then((response) => {
            this.galleryNutriendo = response.data
            // console.log(response);
          })
          .catch((err) => {
            this.galleryNutriendo = undefined;
            console.log(err);
          })
      })

  },
};
</script>

<style scoped>
a:hover {
  color: #d4041b;
}
.card{
  position: static;
}
.col-sm-6{
  position: static;
}
.ol-sm-4{
  position: static;
}
</style>